import * as Yup from "yup";

const PersonalGoalSchema = Yup.object().shape({
  personalGoal: Yup.string().required("Personal goal is required"),
});

export default PersonalGoalSchema;
